<div *ngIf="type === 'circle'" class="skeleton skeleton__circle" [style.width]="width" [style.height]="height"></div>
<div *ngIf="type === 'rectangle'" class="skeleton skeleton__text" [style.width]="width" [style.height]="height"></div>
